export type { BackToTopProps, BackToTopClassKey } from './BackToTop.types';
export { default } from './BackToTop';
